// extracted by mini-css-extract-plugin
module.exports = {"banner":"TemplateForm_banner__2Y-3d","card":"TemplateForm_card__UUshG","title":"TemplateForm_title__1Hqu4","footer":"TemplateForm_footer__3ZzxE"};